import React from 'react'
import LoadingButton from '../loading-button'
import type { AddToDiscoUser } from 'types/user'

type Props = {
  user: AddToDiscoUser
  captchaToken?: string
  errorCode?: string | null | undefined
  isTransitioning?: boolean
}

const LoginButton = ({
  user,
  captchaToken,
  errorCode,
  isTransitioning,
}: Props): React.ReactNode => {
  const { loggingIn, showLoginError, mfaCodeRequired } = user
  const loading = loggingIn || isTransitioning

  if (mfaCodeRequired) {
    return (
      <LoadingButton
        type="submit"
        size="3"
        color="gray"
        variant="solid"
        highContrast
        radius="medium"
        loading={loading}
        loadingLabel="Verifying…"
        data-testid="button-black"
      >
        Verify
      </LoadingButton>
    )
  }

  return (
    <LoadingButton
      type="submit"
      size="3"
      color="gray"
      variant="solid"
      highContrast
      radius="medium"
      disabled={
        showLoginError && errorCode === 'CAPTCHA_REQUIRED' && !captchaToken
      }
      loading={loading}
      loadingLabel="Signing in…"
      data-testid="button-black"
    >
      Sign in to DISCO
    </LoadingButton>
  )
}

export default LoginButton
